import {Section, SectionItem} from 'common/components/items-menu/types';
import {SelectionState} from 'common/components/items-menu/constants';
import {GetSortedMenuSections} from 'common/query-builder/query-block/properties-menu/types';
import {TableColumn} from 'common/components/table/types';

export interface ButtonActionOption {
  eventName: string;
  label: string;
  disabled?: boolean;
  type?: string;
  icon?: string;
  tooltip?: string;
  disabledTooltip?: string;
  toolTipMaxWidthStyle?: string;
  href?: string;
  target?: string;
}

export interface SelectActionOption {
  eventName: string;
  label: string;
  sections: Section[];
  icon?: string;
  menuWidth?: number;
  menuHeight?: number;
}

export type ActionOption = ButtonActionOption | SelectActionOption;

export enum FilterType {
  /** user propertes filter */
  UserProperties = `user-properties`,
  /** filter that displays one kind of filter */
  Simple = `simple`,
  /** filter that displays multiple filter types in one */
  Complex = `complex`,
}

export interface FilterSimpleConfig {
  filterType?: FilterType.Simple;
  name: string;
  noFilterLabel?: string;
  label?: string;

  applyButton?: string;
  /** can select multiple labels for multi-filtering */
  multiple?: boolean;
  sections: Section[];
  menuWidth?: number;
  theme?: string; // button theme
}

export interface FilterComplexConfig {
  filterType?: FilterType.Complex;
  name: string;
  noFilterLabel?: string;
  label?: string;

  sections: Section[];
  /** can select multiple labels for multi-filtering */
  multiple?: boolean;
  menuWidth?: number;
}

export interface QueryBlockItem {
  value: string;
  resourceType: string;
  label?: string;
}

export interface FilterUserPropertiesConfig {
  filterType: FilterType.UserProperties;
  noFilterLabel?: string;

  projectId?: number;
  singleDataGroup?: string;
  workspaceId?: number;
  selected?: QueryBlockItem[];
  getSortedMenuSections?: GetSortedMenuSections;
}

export type FilterSelectConfig = FilterSimpleConfig | FilterComplexConfig;

export type GetFilterSortedMenuSections = (name, section: Section[]) => Section[];

export type ClickActionEvent = CustomEvent<{
  fromIndex: number;
  toIndex: number;
  column: TableColumn;
  columns: TableColumn[];
}>;

export type FilterMenuChangeEvent = CustomEvent<{
  name: string;
  isOpen: boolean;
}>;

export type FilterSelectAllEvent = CustomEvent<{
  name: string;
  selectionState: SelectionState;
  previousSelected: Section[];
  selected: Section[];
}>;

export type UpdateInputEvent = CustomEvent<{
  value: string;
}>;

export type ApplyFilterEvent = CustomEvent<{selected?: SectionItem[]; name: string}>;
